import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import StatusEditService from 'app/admin/status/service/StatusEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import CaptchaTypeEditService from '../../captchatype/service/CaptchaTypeEditService';

const config = {
	key: 'statusEditForm',
	text: 'Status',
	textKey: 'status',
	service: StatusEditService,
	icon: 'person',
	fields: [
		{
			key: 'key',
			text: 'Names',
			textKey: 'key',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'value',
			text: 'Value',
			textKey: 'value',
			component: EditFormTextField,
			required: true
		}
	]
};

function StatusEditForm() {
	return <EditFormPage config={config} />;
}

export default StatusEditForm;